import TemplateView from '../../../../../../js/TemplateView'
import messageResource from '../../../../../../js/messageResource'
import {DateFormat} from '../../../../../../js/date_format'
import {FEEDS_TOOLTIP_EXTRA_CLASS} from '../../../constants'
import {formatUserName} from '../../../utils'
import tooltip from '../../../../../../js/SimpleSingletonTooltip'

export default class FeedNameCell extends TemplateView {
    constructor({
        name,
        createdDate,
        creator,
        editedDate = null,
        editor = null,
        onNameClick = () => {},
    }) {
        super()

        this.params = {
            name,
            createdDate,
            creator,
            editedDate,
            editor,
        }

        this.callbacks = {
            onNameClick,
        }
    }

    templateHtml() {
        return `<div class='feedNameCell'>
                    <span class='feedName'/>
                    <div class='createdBy'>
                        <div class='creationText'>
                            <div class='createdPrefix'>
                                <%=createdPrefix%>
                            </div>                      
                            <div class='creatorName'/>
                            <div class='createdDate'/> 
                            <div class='editedMark'>
                                <%=edited%>
                            </div>     
                        </div>
                    </div>
                </div>`
    }

    messageKeys() {
        return {
            createdPrefix: 'icalendar.page.table.created',
            edited: 'icalendar.page.table.edited',
        }
    }

    afterRender() {
        const dateFormat = new DateFormat(window.SystemSettings.dateFormat)
        const $creationText = this.find('.creationText')
        const $creatorNameEl = $creationText.find('.creatorName')
        const creatorName = formatUserName(this.params.creator)
        $creatorNameEl.text(creatorName)
        $creatorNameEl.prop('title', creatorName)
        $creationText.find('.createdDate')
                     .text(`${messageResource.getMessage('common.on.preposition')} ${dateFormat.formatDate(this.params.createdDate)}`)

        const $feedName = this.find('.feedName')
        $feedName.text(this.params.name)
        $feedName.prop('title', this.params.name)
        $feedName.on('click', this.callbacks.onNameClick)

        const $editedMark = this.find('.editedMark')

        if (this.params.editedDate && this.params.editor) {
            let tooltipText = messageResource.getMessage('icalendar.page.table.edited_by',
                [
                    formatUserName(this.params.editor),
                    dateFormat.formatDate(this.params.editedDate)
                ]
            )

            tooltip($editedMark, {
                extraClass: FEEDS_TOOLTIP_EXTRA_CLASS,
                text: tooltipText
            })
        }

        $editedMark.toggle(!!this.params.editedDate && !!this.params.editor)
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/cells/FeedNameCell.js